<template>
  <div :id="element"></div>
</template>
<script>
import ApexCharts from 'apexcharts';
import { mergeChartTheme } from '@/util/chartTheme';

export default {
  name: 'ApexChart',
  props: ['element', 'chartOption', 'isLive'],
  data() {
    return {
      chart: null,
    };
  },
  computed: {
    themeResolved() {
      return this.$store.state.theme.resolved;
    },
  },
  watch: {
    // ganti tema tanpa reload, gak sentuh series
    themeResolved(theme) {
      if (!this.chart) return;
      const options = mergeChartTheme(this.chartOption, theme);
      delete options.series;
      this.chart.updateOptions(options, false, false);
    },
  },
  mounted() {
    const selector = `#${this.element}`;
    const options = mergeChartTheme(this.chartOption, this.themeResolved);
    this.chart = new ApexCharts(document.querySelector(selector), options);
    setTimeout(() => {
      if (this.chart) this.chart.render();
    }, 500);
  },
  beforeDestroy() {
    if (this.chart) {
      this.chart.destroy();
      this.chart = null;
    }
  },
};
</script>
